import React from "react"
import DatePicker from "react-datepicker";

import ProductInformationRow from './ProductInformationRow';
import { workOrderTitles } from "../../../constants/work-order-titles";
import { useParams } from 'react-router-dom';
import CustomInput from '../../../components/atoms/Input';
import { WorkOrderService } from "../../../service";
import { useState } from "react";
import { useEffect } from "react";
import CustomSpinner from "../../../components/atoms/CustomSpinner";
import { useSelector } from "react-redux";

function ViewWorkOrder({ title }) {

    const [workOrderForm, setWorkOrderForm] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const user = useSelector(state => state.auth.user);
    // 👇️ get ID from url
    const params = useParams();

    const getWorkOrderData = async () => {

        setIsLoading(true)
        const workOrderData = await WorkOrderService.getWorkOrder(params.id)
        try {
            setWorkOrderForm(workOrderData)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        if (!workOrderForm) {
            getWorkOrderData()
        }

    }, [params, workOrderForm])

    const CustomDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
        <CustomInput
            onClick={onClick}
            ref={ref}
            className={'work-order-form-information-item'}
            id={'work-order-form-date'}
            name={'work order'}
            defaultValue={workOrderForm?.date}
            workorder
        />
    ));

    return (
        <div className='work-order-form main-container view-work-order'>
            {
                isLoading ?
                    <CustomSpinner /> :
                    <div className='form-table'>
                        <div className='work-order-form-title no-action-allowed'>
                            <h2>{title} </h2>
                            <div className='work-order-information'>
                                <div className="header-item-container">
                                    <span className='header'>Takip No:</span>
                                    <CustomInput
                                        className={'work-order-form-information-item'}
                                        id={'work-order-form-id'}
                                        name={'workOrderId'}
                                        label={'Takip No'}
                                        defaultValue={workOrderForm?.workOrderId}
                                        workorder
                                        type={"number"}
                                    />
                                </div>
                                <div className="header-item-container">
                                    <span className='header'>Tarih</span>
                                    <DatePicker
                                        key={'date-picker'}
                                        locale={'tr'}
                                        customInput={
                                            <CustomDatePickerInput />
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='work-order-titles'>
                            {workOrderTitles
                            .filter(item => item != 'Satır Ekle')
                            .map((title, index) => (
                                <div key={index} className='column row-cell'>
                                    {title}
                                </div>
                            ))}
                        </div>
                        <div className='form-row-container'>
                            {
                                workOrderForm?.rows.map((item, index) => {
                                    return (
                                        <ProductInformationRow readOnly rowData={item} key={index} />
                                    )
                                })
                            }
                        </div>
                        <div className="confirmation">
                            {
                                workOrderForm?.confirmData.name ?
                                    <span>
                                        <span className="confirming-person">{workOrderForm.confirmData.name} </span>
                                    tarafından onaylandı</span> :
                                    <span>Onay bilgisi bulunmamaktadır</span>
                            }
                        </div>
                    </div>
            }
        </div>
    );
}
export default ViewWorkOrder;
